class CategoryValidator {
    categoryToInvalidate;
    /**
     * @param {string[]} categoriesToInvalidate
     */
    constructor(categoriesToInvalidate) {
        this.categoryToInvalidate = categoriesToInvalidate;
    }
    /**
     * @param {Konva.Shape} target
     * @returns {boolean}
     */
    validate(target) {
        const targetCategory = target.getAttr('category');
        if (targetCategory === undefined) {
            return false;
        }
        for (const excludedCategory of this.categoryToInvalidate) {
            if (targetCategory === excludedCategory) {
                return false;
            }
        }
        return true;
    }
}

export { CategoryValidator };
//# sourceMappingURL=CategoryValidator.js.map
